import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/bombas/BombasAutocebantes/BombasAutocebantes1.png';
import Img2 from '../../img/products/bombas/BombasAutocebantes/BombasAutocebantes2.png';
import Img3 from '../../img/products/bombas/BombasAutocebantes/BombasAutocebantes3.png';
import Img4 from '../../img/products/bombas/BombasCentrifugas.png';

const BombasAutocebantes = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Bombas Autocebantes</h2>

      {/* Estilos inline o puedes mover esto a tu CSS */}
      <style>{`
        .img-hover-zoom {
          transition: transform 0.3s ease;
        }

        .img-hover-zoom:hover {
          transform: scale(1.05);
        }
      `}</style>

      <div className="row align-items-end mb-2">
        {/* Columna Izquierda: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Las bombas autocebantes son un tipo de bomba centrífuga diseñada para operar sin la necesidad
             de un cebado manual. Estas bombas son capaces de iniciar el bombeo de líquido incluso si están
              instaladas por encima del nivel del líquido a bombear, lo que las hace muy prácticas y 
              eficientes para diversas aplicaciones.
          </p>
          <p className="lead text-justify">
            La cámara de succión está diseñada para retener una cantidad de líquido que facilita el proceso
            de cebado. No requieren cebado manual, lo que facilita su uso y ahorra tiempo.
          </p>
          <p className="lead text-justify">
            Se pueden instalar en lugares donde el nivel del líquido a bombear está por debajo de la bomba.
            Funcionan tanto en horizontal como en vertical, lo que las hace aptas para diversas aplicaciones.
          </p>
        </div>
        {/* Columna derecha: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-4">
            <div className="col-6">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 1" />
            </div>
            <div className="col-6">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 2" />
            </div>
            <div className="col-6">
              <img src={Img3} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 3" />
            </div>
            <div className="col-6">
              <img src={Img4} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 4" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BombasAutocebantes;
